<template>
  <v-card
    class="message-preview-card"
    outlined
    rounded="lg"
    :color="selected ? 'primary' : ''"
    style="background-color: var(--v-grey-8-base) !important;"
    @click="handleSelect"
  >
    <v-row no-gutters>
      <!-- 左側：LINE 訊息 -->
      <v-col cols="6" class="pa-4">
        <div class="grey--text text--darken-2 font-weight-medium">LINE 訊息</div>

        <v-sheet class="rounded-lg overflow-hidden line-card-elevation mt-2">
          <v-img
            :src="leftSrc"
            :alt="`LINE-${type}`"
            aspect-ratio="1"
            contain
          />
        </v-sheet>
      </v-col>

      <!-- 右側：簡訊 -->
      <v-col cols="6" class="pa-4">
        <div class="grey--text text--darken-2 font-weight-medium mb-2">簡訊</div>

        <v-sheet class="rounded-lg overflow-hidden line-card-elevation mt-2">
          <v-img
            :src="rightSrc"
            :alt="`SMS-${type}`"
            max-height="140"
            contain
          />
        </v-sheet>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'MessageCard',

  props: {
    // 約診訊息類型：可依你的實際業務命名
    // reminder=看診提醒、review=評價邀請、care=術後關懷
    type: {
      type: String,
      default: 'review',
      validator: v => ['reminder', 'review', 'care'].includes(v),
    },
    // 是否被選取（外框高亮）
    selected: {
      type: Boolean,
      default: false,
    },
    // 點擊卡片是否可選
    clickable: {
      type: Boolean,
      default: true,
    },
    // 額外覆蓋圖片用（可選），格式同 imagesMapping 的結構
    images: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    // 預設圖片 mapping，換成你專案內的實際圖檔
    imagesMapping() {
      return {
        reminder: {
          left: require('@/assets/message-preview/reminder-line.png'),
          right: require('@/assets/message-preview/reminder-sms.png'),
        },
        review: {
          left: require('@/assets/message-preview/review-line.png'),
          right: require('@/assets/message-preview/review-sms.png'),
        },
        care: {
          left: require('@/assets/message-preview/care-line.png'),
          right: require('@/assets/message-preview/care-sms.png'),
        },
      };
    },
    leftSrc() {
      const merged = { ...this.imagesMapping[this.type], ...this.images[this.type] };
      return merged.left;
    },
    rightSrc() {
      const merged = { ...this.imagesMapping[this.type], ...this.images[this.type] };
      return merged.right;
    },
  },

  methods: {
    handleSelect() {
      if (!this.clickable) return;
      this.$emit('select');
    },
  },
};
</script>

<style scoped>
/* Your styles here */
</style>
